import { render } from "./VisuallyImpaired.vue?vue&type=template&id=3a38bee5"
import script from "./VisuallyImpaired.vue?vue&type=script&lang=js"
export * from "./VisuallyImpaired.vue?vue&type=script&lang=js"

import "./VisuallyImpaired.vue?vue&type=style&index=0&id=3a38bee5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__